/* Ziggy Cuts — cart-drawer.js
   Native AJAX cart: add-to-cart forms open the drawer; quantity
   changes use /cart/change.js. No dependencies. */

(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-items]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var lastFocus = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.setAttribute('data-open', 'true');
    // preventScroll so moving focus into the drawer never jumps the page
    drawer.querySelector('[data-cart-close]').focus({ preventScroll: true });
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    drawer.setAttribute('data-open', 'false');
    document.removeEventListener('keydown', onKeydown);
    // restore focus without scrolling the page back to the trigger
    if (lastFocus && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  function render(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count > 0 ? cart.item_count : '';
    });
    subtotalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<p class="cart-drawer__empty">' + itemsEl.dataset.emptyText + '</p>';
      return;
    }

    itemsEl.innerHTML = cart.items
      .map(function (item) {
        return (
          '<div class="cart-line" data-key="' + item.key + '">' +
            '<div class="cart-line__img">' +
              (item.image
                ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/, '_180x$1') + '" alt="" loading="lazy">'
                : '') +
            '</div>' +
            '<div>' +
              '<p class="cart-line__title">' + item.product_title + '</p>' +
              (item.variant_title && item.variant_title !== 'Default Title'
                ? '<p class="cart-line__variant">' + item.variant_title.replace(' / ', ' · ') + '</p>'
                : '') +
              '<p class="cart-line__meta">' + money(item.final_line_price) + '</p>' +
              '<div class="cart-line__qty">' +
                '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span aria-live="polite">' + item.quantity + '</span>' +
                '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="cart-line__remove text-gray" data-qty-set="0" aria-label="Remove ' + item.product_title + '">&times;</button>' +
          '</div>'
        );
      })
      .join('');
  }

  function refresh(openAfter) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        if (openAfter) open();
        return cart;
      });
  }

  function changeQty(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  /* Intercept product forms */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refresh(true);
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  });

  /* Drawer controls */
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__overlay')) {
      close();
      return;
    }
    var line = e.target.closest('.cart-line');
    if (!line) return;

    var stepBtn = e.target.closest('[data-qty-change]');
    if (stepBtn) {
      var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      changeQty(line.dataset.key, Math.max(0, current + parseInt(stepBtn.dataset.qtyChange, 10)));
    }
    var setBtn = e.target.closest('[data-qty-set]');
    if (setBtn) changeQty(line.dataset.key, parseInt(setBtn.dataset.qtySet, 10));
  });

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refresh(true);
    });
  });

  /* Public API for quick-add / sticky bar */
  window.ZiggyCart = {
    open: open,
    refresh: refresh,
    addVariant: function (id, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return refresh(true); })
        .catch(function () { window.location.href = '/cart'; });
    }
  };

  refresh(false);
})();
